module.exports = __webpack_public_path__ + "img/female.a384e7ee.jpg";